import type { Logger, EditorSDK } from '@wix/wix-data-client-common-standalone'
import {
  findError,
  isMissingPermissionsError,
} from '@wix/wix-data-client-common-standalone'
import type { HttpClient } from '@wix/http-client'
import { CMS } from '@wix/app-definition-ids'
import { installApp } from '@wix/ambassador-apps-v1-app-instance/http'
import { V1TenantType } from '@wix/ambassador-apps-v1-app-instance/types'

export const installCMSAutomationsApp = async ({
  logger,
  httpClient,
  metaSiteId,
  editorSdkProxy,
}: {
  logger: Logger
  httpClient: HttpClient
  metaSiteId: string
  editorSdkProxy: EditorSDK
}): Promise<void> => {
  const isInstalled =
    !!(await editorSdkProxy.document.tpa.app.getDataByAppDefId(CMS))

  if (isInstalled) {
    return
  }

  try {
    await httpClient.request(
      installApp({
        tenant: {
          id: metaSiteId,
          tenantType: V1TenantType.SITE,
        },
        appInstance: { appDefId: CMS },
      }),
    )
  } catch (error) {
    if (findError(error, isMissingPermissionsError)) {
      return
    }
    logger.error(
      new Error('Failed to install CMS Automations app', {
        cause: error,
      }),
    )
  }
}
